import * as types from '../actions/types';

const defaultState = {
  data: [],
};

const towsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_TOWS:
      return {
        ...state,
        data: [...action.payload],
      };
    default:
      return state;
  }
};

export default towsReducer;
